import { render, staticRenderFns } from "./LightingSolutionList.vue?vue&type=template&id=2d54d5b2&"
import script from "./LightingSolutionList.vue?vue&type=script&lang=js&"
export * from "./LightingSolutionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports